import apiClient from './api.service';

export type FactoryFloorHealthStatus = 'on_track' | 'at_risk' | 'blocked' | 'delayed';

export interface FactoryFloorWorkOrderCard {
  work_order_id: string;
  project_number: string | null;
  work_order_number: string;
  description: string | null;
  operations_count: number;
  ops_done: number;
  ops_running: number;
  ops_on_hold: number;
  ops_overdue: number;
  ops_awaiting_inspection: number;
  operations_health_status: FactoryFloorHealthStatus;
  operations_health_summary: string;
  planned_completion_date: string | null;
  hold_reason: string | null;
  progress_percent: number;
}

export interface FactoryFloorWorkOrdersResponse {
  work_orders: FactoryFloorWorkOrderCard[];
}

const factoryFloorDisplayService = {
  getWorkOrders: () => apiClient.get<FactoryFloorWorkOrdersResponse>('/manufacturing/factory-floor/work-orders'),
};

export default factoryFloorDisplayService;
